<template>
    <div class="c-local-notifications" :id="btnId" >
        <button class="btn" @click.prevent="toggleNotifications">
            <span class="btn--sphere" v-if="containsUnreadMessge"></span>
        </button>
        <div id="notifications" class="notifications">
            <div v-if="listVisible" class="notifications--list">
                <div v-for="notification in notifications" :key="notification.id" class="notifications--list--item"
                    @click="setRead(notification)">
                    <span class="notifications--list--item--left">
                        <span class="notifications--list--item--icon" :class="{read:notification.read}"></span>
                    </span>
                    <span class="notifications--list--item--right" :class="{read:notification.read}" v-html="notification.message"></span>
                </div>
                <div v-if="notifications.length == 0" class="notifications--list--item">
                    {{$t('notifications.empty')}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {formatAppointmentNames} from "@/utils/utils";
import DocumentClickMixin from "@/mixins/DocumentClickMixin";
import LoginMixin from "@/mixins/LoginMixin";
import localforage from "localforage";
import {socketStore} from "@/stores/socket";
import {apiStore} from "@/stores/api";

export default {
    name : "Notifications",
    mixins: [DocumentClickMixin, LoginMixin],
    data() {
        return {
            btnId : "btn-show-notifications",
            listVisible : false,
            notifications: []
        };
    },

    async created() {
        socketStore().on("MOVIE_COMPLETED", this.onCompleted);

        await this.loadNotifications();
    },

    unmounted() {
        socketStore().off("MOVIE_COMPLETED", this.onCompleted);
    },

    computed: {
        containsUnreadMessge() {
            return this.notifications.some(x => !x.read);
        },

        notificationsKey() {
            return "nofications" + this.loggedInSales.id;
        }
    },

    methods: {
        async loadNotifications() {
            const notifications = await localforage.getItem("notifications");
            this.notifications = notifications !== null ? notifications.filter(x => x.sales_id === this.loggedInSales.id) : [];
        },

        toggleNotifications() {
            if (this.listVisible) {
                this.listVisible = false;
            } else {
                setTimeout(() => {
                    this.listVisible = true;
                }, 100);
            }
        },

        async onCompleted(data) {
            console.log("onCompleted", data);
            if (!data.appointment_id) return; // no appointment id, service measurement

            const appointment = await apiStore().getAppointment(data.appointment_id);
            const sales = apiStore().loggedInSales;
            if ((sales.limited && appointment.sales_id === sales.id) || !sales.limited) {
                const link = "<a href=\"/#/appointment-result/" + appointment.id + "/\">" + formatAppointmentNames(appointment) + "</a>";
                const message = this.$t("notifications.message", {name : link});
                this.notifications.unshift({
                    message,
                    sales_id : this.loggedInSales.id,
                    read : false});
                this.listVisible = true;

                if (this.notifications.length >= 5) {
                    this.notifications.pop();
                }
                localforage.setItem("notifications", JSON.parse(JSON.stringify(this.notifications)));
            }
        },

        setRead(notification) {
            notification.read = true;
            localforage.setItem("notifications", JSON.parse(JSON.stringify(this.notifications)));

            this.$forceUpdate();
        },

        documentClickTriggered(e) {
            const parent = e.target.closest("#notifications");

            //hide list if click outside dropdown or click on link
            if ((parent === null && this.listVisible) || e.target.tagName.toLowerCase() === "a") {
                this.listVisible = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.c-local-notifications {
    font-weight: normal;

    .btn {
        @extend .reset-btn;
        background-image : url('/img/icon-user.svg');
        background-repeat : no-repeat;
        background-size: 55%;
        background-position: center;
        width: 2.25rem;
        height: 2.25rem;
        margin-right: 0.5rem;
        position: relative;
        border: solid .05rem #777;
        border-radius: 50%;
        outline: none;

        &--sphere {
            position: absolute;
            top : .1rem;
            right : .1rem;
            width : .5rem;
            height : .5rem;
            border-radius: 50%;;
            background : $color-red;
        }
    }

    .notifications {
        position: relative;
        &--list {
            position: absolute;
            z-index: 50;
            top : .5rem;
            left: -.5rem;
            background : white;
            width: 40rem;
            box-shadow: 0px 4px 6px 1px rgba(0,0,0,0.15), 0px -4px 6px 1px rgba(0,0,0,0.15);

            &--item {
                padding : .7rem 1.5rem;
                font-size: 1.15em;
                display: flex;

                &:not(:first-child) {
                    border-top: solid 1px #aaaaaa;
                }

                &--left {
                    width : 8%;
                }

                &--icon {
                    background-image: url('/img/icon-checkbox.svg');
                    background-repeat: no-repeat;
                    width : 1em;
                    height : 1em;
                    background-repeat: no-repeat;
                    background-position: center;
                    display: block;

                    &.read {
                        background-image: url('/img/icon-checkbox-grey.svg');
                    }
                }

                &--right {
                    width:92%;

                    &.read {
                        opacity: .5;
                    }

                    :deep(a) {
                        color: $color-blue;
                    }
                }
            }

            &:before {
                $triangle : .8rem;
                position: absolute;
                content: ' ';
                width: 0;
                height: 0;
                left : .75rem;
                top : #{-$triangle};
                border-left: math.div($triangle, 1.25) solid transparent;
                border-right: math.div($triangle, 1.25) solid transparent;
                border-bottom: $triangle solid #fff;
            }

        }
    }
}
</style>